var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa-solid:users",
    clipPath: "url(#clip0_34_427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.16005 7.9C5.39555 7.9 6.40005 6.91344 6.40005 5.7C6.40005 4.48657 5.39555 3.5 4.16005 3.5C2.92455 3.5 1.92005 4.48657 1.92005 5.7C1.92005 6.91344 2.92455 7.9 4.16005 7.9ZM19.84 7.9C21.0755 7.9 22.08 6.91344 22.08 5.7C22.08 4.48657 21.0755 3.5 19.84 3.5C18.6045 3.5 17.6 4.48657 17.6 5.7C17.6 6.91344 18.6045 7.9 19.84 7.9ZM20.96 9H18.72C18.104 9 17.5475 9.24407 17.1415 9.63938C18.552 10.3991 19.553 11.7706 19.77 13.4H22.08C22.6995 13.4 23.2 12.9084 23.2 12.3V11.2C23.2 9.98657 22.1955 9 20.96 9ZM12 9C14.1665 9 15.92 7.27782 15.92 5.15C15.92 3.02219 14.1665 1.3 12 1.3C9.83355 1.3 8.08005 3.02219 8.08005 5.15C8.08005 7.27782 9.83355 9 12 9ZM14.688 10.1H14.3975C13.6695 10.4438 12.861 10.65 12 10.65C11.139 10.65 10.334 10.4438 9.60255 10.1H9.31205C7.08605 10.1 5.28005 11.8738 5.28005 14.06V15.05C5.28005 15.9609 6.03255 16.7 6.96005 16.7H17.04C17.9675 16.7 18.72 15.9609 18.72 15.05V14.06C18.72 11.8738 16.914 10.1 14.688 10.1ZM6.85855 9.63938C6.45255 9.24407 5.89605 9 5.28005 9H3.04005C1.80455 9 0.800049 9.98657 0.800049 11.2V12.3C0.800049 12.9084 1.30055 13.4 1.92005 13.4H4.22655C4.44705 11.7706 5.44805 10.3991 6.85855 9.63938Z",
    fill: "#773ADA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.4,
    height: 17.6,
    fill: "white",
    transform: "translate(0.800049 0.199997)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users_icon.97926f4d.svg";
export { ForwardRef as ReactComponent };